//Darktheme Direct Response page


import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import "../style/signupform.css";
import { useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import Checkbox from "@mui/material/Checkbox";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  InputLabel,
  Button,
  Icon,
  Select,
  MenuItem,
  Grid,
  useMediaQuery,
} from "@mui/material";
import { formDataSubmitGoogleEvent, setFormSubmitStateReset } from "./SignupFormReducer";
import { useDispatch } from "react-redux";
import store from "../store";
import { useLocation, useNavigate } from "react-router-dom";
import { useCookies, Cookies } from "react-cookie";
import { DemoHeader } from "./demoheaderfooter/demoheader";
import { DemoFooter } from "./demoheaderfooter/demofooter";

// import {
//   createTheme,
//   styled,
//   useColorScheme,
//   useTheme,
// } from "@mui/material/styles";

// import bannerimg from 'https://all-frontend-assest.s3.amazonaws.com/pece-marketing-deploy/static/media/320-x-50__01__Top%20Banner.bae2f3c608fbae5b6108.jpg';
// import bannerimgg from 'https://all-frontend-assest.s3.amazonaws.com/pece-marketing-deploy/static/media/720-x-100__01__Top%20Banner.bae2f3c608fbae5b6108.jpg';
// import {footerimg} from '../assets/';

import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import MobBanner from "./mob-banner";


// let themeconfig = require("../../src/assets/palette-theme.json");




const Landingnew = (props) => {

  console.warn("<<<<<<<<<< props goes here >>>>>>>>>", props)

  // ===================================themejsonppalette===================================
  // console.log("themeconfig  --- ", themeconfig);
  // const [theme, setTheme] = useState(0);
  // const [currentRes, setCurrentRes] = useState("");
  // const theme1 = useTheme();
  // const desktop = useMediaQuery(theme1.breakpoints.up("lg"));
  // const tablet = useMediaQuery(theme1.breakpoints.up("sm"));
  // const mobile = useMediaQuery(theme1.breakpoints.up("xs"));

  // useEffect(() => {
  //   // Update the document title using the browser API
  //   console.log("themeconfig", themeconfig, desktop);

  //   if (desktop) {
  //     console.log("in desktop block");
  //     setCurrentRes("desktop");
  //     console.log("in desktop block", currentRes);
  //   }
  //   if (!desktop && tablet) setCurrentRes("tablet");
  //   console.log("in desktop block", currentRes);

  //   if (!desktop && !tablet && mobile) setCurrentRes("mobile");
  //   console.log("in desktop block", currentRes);

  //   console.log(desktop, tablet, mobile, "////", currentRes);
  //   setTheme(themeconfig);

  //   //   console.log(sizes,'ss');
  // }, []);
  // ===================================themejsonppalette===================================


  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    control,
    clearErrors,
    formState: { errors },
    setError,
    reset,
  } = useForm();
  const [options, setOptions] = useState([]);
  const [options_city, setOptionsCity] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading_city, setLoadingCity] = useState(false);
  const [state_id, setStateId] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formSubmisionState, setFormSubmisionState] = useState(0);

  const [formData, setFormDataCookie] = useCookies(["formsubmitdata"]);
  const [formDataState, setFormDatastate] = useState(null);
  const [dataSubmissionId, setDataissionIdCookie] = useCookies([
    "formsubmitdata",
  ]);

  const cookies = new Cookies();
  const practiceId = cookies.get("practiceIds");
  console.warn("practice id goes here", practiceId);

  const [injectData, setInjectData] = useState("");

  useEffect(() => {
    setInjectData('');
    console.log("in ifff ---- ", practiceId, props);
    if (
      practiceId !== "62e30d1ddbad8d4a7bf7e845" &&
      practiceId != "undefined" &&
      practiceId != null
    ) {
      setInjectData(" and Medicaid .");
      console.log("in ifff ---- ", practiceId, "practiceId");
    } else {
      console.log("in else");
    }
  }, [practiceId]);

  const params = useParams();
  const [subIDs, setSubIDs] = useState(null);
  const [isSubID, setIsSubID] = useState(false);
  const paramUniqueCode = params._id ? params._id : params.practiceId;
  const [practiceName, setPracticeName] = useState([]);
  const [header, setHeader] = useState([]);
  const [footer, setFooter] = useState([]);
  const [bannerData, setBannerData] = useCookies(["bannerData"]);
  const [techData, setTechData] = useState([]);
  const [practiceData, setPracticeData] = useState([]);
  const [marketingDetailsData, setMarketingDetailsData] = useState([]);

  // ------------- ##########################------------------
  /*
  useEffect(() => {
    // setTimeout(() => {

    for (let key in params) {
      if (key === "*") {
        console.log("paramUniqueCode key", params[key]);
        let linkSubIDs = params[key].split("/");
        setSubIDs(params[key].split("/"));
        console.log("paramUniqueCode linkSubIDs 555", linkSubIDs);
        console.log("paramUniqueCode subIDs 555", subIDs);
      }
    }
    if (!isSubID) setIsSubID(true);

    console.log("paramUniqueCode 555", paramUniqueCode);

    // Fetching IP Address
    if (isSubID) {
      fetch("https://ipinfo.io/?format=json&token=9797c42b93078a")
        .then((results) => results.json())
        .then((data) => {
          console.log("<<<<<<<<<<< data goes here >>>>>>>>>", data);
          if (data) {
            const reqData = {
              method: "POST",
              headers: { "Content-type": "application/json" },
              body: JSON.stringify({
                condition: {
                  link_value: paramUniqueCode
                    ? paramUniqueCode
                    : "zenithmedical",
                  subId: subIDs,
                  ip_details: data,
                },
              }),
            };

            // Fetching Link Value all data
            fetch(
              process.env.REACT_APP_API_URL + "asyncapi/fetch-firstpagedata",
              reqData
            )
              .then((results) => results.json())
              .then((data) => {
                console.log("<<<<<<<<<<< data goes here >>>>>>>>>", data);
                // setBannerData(data.res);
                data.res.res.map((d) => {
                  setPracticeName(d.added_for);
                  if (d.banner_type === "header") {
                    setHeader(d.image);
                  } else {
                    setFooter(d.image);
                  }
                });
                setBannerData("bannerData", data.res.res, { path: "/" });
                setTechData(data.tech_id.res);
                setPracticeData(data.practice_details.res);
                if (
                  data.marketinglist_details &&
                  data.marketinglist_details.res &&
                  data.marketinglist_details.res.length
                ) {
                  data.marketinglist_details.res.forEach((e) => {
                    if (e.link_value === paramUniqueCode) {
                      setMarketingDetailsData(e);
                    }
                  });
                }
                // setTimeout(() => {
                //   console.log(techData)
                //   settechIdsCookie("techIds", techData, { path: "/" })
                //   setPracticeIdCookie("practiceIds", practiceData._id, { path: "/" })
                // }, 1000)
              });
          }
        });
    }
    // }, 1000)
  }, [isSubID]);

  }, [isSubID]);*/

  // ------------- ##########################------------------

  const headerimage2 =
    "https://all-frontend-assets.s3.amazonaws.com/Pece+marketing+landing/assets/images/headersectionbanner.webp";
  const image1 =
    "https://all-frontend-assets.s3.amazonaws.com/Pece+marketing+landing/assets/images/signuppage_no.1tagimg1.webp";
  // const image2 = "https://all-frontend-assets.s3.amazonaws.com/Pece+marketing+landing/assets/images/signup_bannerblock_screensortimg1.webp";
  const image2 =
    "https://d37pbainmkhx6o.cloudfront.net/pecemarketinglandingpage/assets/images/signup_bannerblock_screensortimg1.webp";

  const image3 =
    "https://all-frontend-assets.s3.amazonaws.com/Pece+marketing+landing/assets/images/signuppage_bannergirlimg1.webp";

  // const image4 = "https://all-frontend-assets.s3.amazonaws.com/Pece+marketing+landing/assets/images/signuppage_block1_leftimg1.png";
  const image4 =
    "https://d37pbainmkhx6o.cloudfront.net/pecemarketinglandingpage/assets/images/signuppage_block1_leftimg1.webp";

  const image5 =
    "https://all-frontend-assets.s3.amazonaws.com/Pece+marketing+landing/assets/images/signuppage_block2_rightimg1.webp";
  const image6 =
    "https://all-frontend-assets.s3.amazonaws.com/Pece+marketing+landing/assets/images/signuppage_block3_humanbody.webp";
  const image7 =
    "https://all-frontend-assets.s3.amazonaws.com/Pece+marketing+landing/assets/images/signuppage_block3_blk1img.webp";
  const image9 =
    "https://all-frontend-assets.s3.amazonaws.com/Pece+marketing+landing/assets/images/signuppage_block3_blk2img.webp";

  // const image10 = "https://all-frontend-assets.s3.amazonaws.com/Pece+marketing+landing/assets/images/signuppage_blk2_contentimg2_left.png";
  const image10 =
    "https://all-frontend-assets.s3.amazonaws.com/Pece+marketing+landing/assets/images/signuppage_blk2_contentimg2_leftnew1.webp";

  const contentblk1right =
    "https://all-frontend-assets.s3.amazonaws.com/Pece+marketing+landing/assets/images/cs2.webp";
  const contentblk1right1 =
    "https://all-frontend-assets.s3.amazonaws.com/Pece+marketing+landing/assets/images/cs3.webp";
  const contentblk1right4 =
    " https://all-frontend-assets.s3.amazonaws.com/Pece+marketing+landing/assets/images/cs4.webp";
  const contentblk1right5 =
    "https://all-frontend-assets.s3.amazonaws.com/Pece+marketing+landing/assets/images/darkthemesignupblockfour_contentblk2_leftimg1.webp";
  const pointerimg1 =
    "https://all-frontend-assets.s3.amazonaws.com/pece-marketing-landingpage/assets/images/lgtsightup_pointerimg.webp";
  // const characterimg1 = "https://all-frontend-assets.s3.amazonaws.com/medigrade/assets/images/science/carecter.webp";
  // const footerimg = "https://all-frontend-assets.s3.amazonaws.com/pece-marketing-landingpage/assets/images/footerbanner_lightmain.png";
  const tsnewclipimage1 =
    "https://all-frontend-assets.s3.amazonaws.com/pece-marketing-landingpage/assets/images/tsnewclipimage1.webp";
  const tsnewclipimage2 =
    "https://all-frontend-assets.s3.amazonaws.com/pece-marketing-landingpage/assets/images/tsnewclipimage2.webp";
  const tsnewclipimage3 =
    "https://all-frontend-assets.s3.amazonaws.com/pece-marketing-landingpage/assets/images/tsnewclipimage3.webp";
  const tsnewclipimage4 =
    "https://all-frontend-assets.s3.amazonaws.com/pece-marketing-landingpage/assets/images/tsnewclipimage4.webp";
  const tsnewclipimage5 =
    "https://all-frontend-assets.s3.amazonaws.com/pece-marketing-landingpage/assets/images/tsnewclipimage5.webp";
  const tsnewclipimage6 =
    "https://all-frontend-assets.s3.amazonaws.com/pece-marketing-landingpage/assets/images/tsnewclipimage6.webp";
  const tsnewclipimage7 =
    "https://all-frontend-assets.s3.amazonaws.com/pece-marketing-landingpage/assets/images/tsnewclipimage7.webp";
  const tsnewclipimage8 =
    "https://all-frontend-assets.s3.amazonaws.com/pece-marketing-landingpage/assets/images/tsnewclipimage8.webp";

  store.subscribe(() => {
    const storeData = store.getState();
    setFormSubmisionState(storeData.formSubmitSlice.formSubmisionState);
    setFormDatastate(storeData.formSubmitSlice.submissionSucessData);
  });

  // form submit function
  const onSubmit = (data) => {
    console.log("props", props);
    setFormDataCookie("formsubmitdata", data, { path: "/" });
    data.is_pecemarketing = 1; // for identify dark-theme
    data.practice_id = practiceId;

    if (props !== "undefined" && props.practiceName !== "undefined")
      data.practice_name =
        props.practiceName.length === 0 ? "" : props.practiceName;
    // if (props !== 'undefined' && props.practiceName !== 'undefined')
    data.practice_name =
      props.practiceName.length === 0 ? "" : props.practiceName;
    data.paging_step = 1;
    data.uniqueCode = props.uniqueCode;
    data.domain_url = "pece";
    data.link_by = props.marketingDetailsData
      ? props.marketingDetailsData.link_by
      : "";
    data.paging_step_one_submission = new Date().getTime();
    data.link_sub_id = props.marketingSubIDs ? props.marketingSubIDs : [];
    data.link_techs = props.techData;
    data.link_location = props.marketingDetailsData.location;
    console.log("submitted data", data);
    dispatch(formDataSubmitGoogleEvent(data));

    reset();
  };

  useEffect(() => {
    if (formSubmisionState === 2) {
      console.log("store.getState()", store.getState());
      setDataissionIdCookie(
        "formsubmitdata",
        store.getState().formSubmitSlice.submissionSucessData,
        { path: "/" }
      );
      navigate(
        `/quickintake/${store.getState().formSubmitSlice.submissionSucessData._id
        }`
      );
      dispatch(setFormSubmitStateReset());
      reset();
    }
  }, [formSubmisionState]);

  // custome phone number error mesage
  const phoneNumberErrorMessage = {
    required: "Phone Number is Required",
    // minLength: "Phone Number should be 10 digit",
    maxLength: "Phone Number should not exceed 20 digit",
  };

  const zipcodeErrorMessage = {
    required: "Zip Code is Required",
    minLength: "Zip Code should be 5 digit",
    maxLength: "Zip Code should be 5 digit",
  };

  const emailErrorMessage = {
    required: "Email ID is Required",
    pattern: "Please Enter Valid Email",
  };
  const genderErrorMessage = {
    required: "Gender is Required"
  };

  useEffect(() => {
    onChangeState();
  }, []);

  // fetch autocomplete state
  const onChangeState = async (value) => {
    setLoading(true);
    // this default api does not support searching but if you use google maps or some other use the value and post to get back you reslut and then set it using setOptions
    // console.log(value);
    const requestOptions = {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify({ search_str: value }),
    };
    const response = await fetch(
      process.env.REACT_APP_API_URL + "api9/fetch-allstates",
      requestOptions
    );
    const resResult = await response.json();
    const data = resResult.sates.map((data) => {
      return { label: data.name, _id: data._id, abbr: data.abbreviation };
    });

    setOptions(data);
    setLoading(false);
  };

  // fetch autocomplete City
  const onChangeCity = async (value, id) => {
    setLoadingCity(true);
    // this default api does not support searching but if you use google maps or some other use the value and post to get back you reslut and then set it using setOptions
    const requestOptions = {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify({ search_str: value, state_id: state_id }),
    };
    const response = await fetch(
      process.env.REACT_APP_API_URL + "api9/fetch-allcity",
      requestOptions
    );
    const resResult = await response.json();
    const city_data = resResult.sates.map((data) => {
      return { label: data.city_name, _id: data._id };
    });

    setOptionsCity(city_data);
    setLoadingCity(false);
  };

  // {/*################*/}###### Ussing for setting isDemo Flag #########################

  const location = useLocation();
  console.log("from appointment booking >>>", location.pathname);
  const [isDemo, setDemo] = useState("");
  const [isMobiDemo, setMobiDemo] = useState("");

  useEffect(() => {
    if (location.pathname.includes("demo")) {
      setDemo(1);
    }
  }, []);

  useEffect(() => {
    // if (location.pathname.includes('demo') && !location.pathname.includes('demomobi')) {
    //   setDemo(1)
    // }
    if (location.pathname.includes("demomobi")) {
      setMobiDemo(1);
      // setDemo(0)
    }
  }, []);

  const handleChange = (event) => {
    // setAge(event.target.value as string);
    setValue("gender", event.target.value);
  };
  // {/*################*/}{/*################*/}{/*################*/}##############

  /*------ Formatted Phone Field Start ------*/
  function formatPhoneText(value) {
    value = value.trim().replaceAll("-", "");
    value = value.trim().replaceAll("(", "");
    value = value.trim().replaceAll(")", "");
    value = value.trim().replaceAll(" ", "");


    if (value.length > 3 && value.length <= 6)
      value = "(" + value.slice(0, 3) + ")" + " " + value.slice(3);
    else if (value.length > 6)
      value = "(" + value.slice(0, 3) + ")" + " " + value.slice(3, 6) + "-" + value.slice(6);

    return value;
  }

  function validatePhone(p) {
    var phoneRe = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
    var digits = p.replace(/\D/g, "");
    return phoneRe.test(digits);
  }

  const setPhoneNumber = ((e) => {
    // console.log("target value",e.target.value)
    var formatted = formatPhoneText(e.target.value);
    // var isError = (validatePhone(formatted) || formatted.length === 0);
    setValue("phone_number", formatted);
  })
  /*------ Formatted Phone Field End ------*/


  return (
    <React.Fragment>
      <div className="landingnew_wrpr">
        <div className="signup_main">
          <div className="headerblock">
            <div className="mknewcontainer">
              {/* <img src={header} className="" /> */}



              {isMobiDemo != 1 ? <img src={props.header} /> : ""}

              {/* <img src={props.header} /> */}
              {/* <img src="https://all-frontend-assest.s3.amazonaws.com/pece-marketing-deploy/static/media/720-x-100__01__Top%20Banner.bae2f3c608fbae5b6108.jpg" /> */}
              {/* {
                isDemo == 1 ? (
                  <img src="https://all-frontend-assest.s3.amazonaws.com/pece-marketing-deploy/static/media/720-x-100__01__Top%20Banner.bae2f3c608fbae5b6108.jpg" className="mobileBanner" />) : ""
              } */}
              <div className="mobiban">
                {isMobiDemo == 1 ? (
                  <img
                    src="https://all-frontend-assest.s3.amazonaws.com/pece-marketing-deploy/static/media/720-x-100__01__Top%20Banner.bae2f3c608fbae5b6108.jpg"
                    className="mobileBanner"
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>


          {/* ===================Landing_Page_topview Texts(tab&mobileview)=====================================  */}

          <Grid container className="topheader_mainwrpr">
            <div className="mknewcontainer">

              <MobBanner
                practiceName={props.practiceName}
                practiceLogo={props.practiceData.img_url}
                practiceAddress={props.marketingDetailsData.fulladdress?.address}
                practiceCity={props.marketingDetailsData.fulladdress?.city}
                practicePh={props.marketingDetailsData.fulladdress?.phone_no}
                practicestate={props?.marketingDetailsData?.fulladdress?.state}
                practicezip={props?.marketingDetailsData?.fulladdress?.zip}

              />

              <div className="listwrapper mobileviewlist">
                <div className="listsubwrapperbg">
                  <div className="blk1bottomtxt">
                    <h1>
                      Our quick, easy and non-invasive test checks for over 20
                      Disease States including:
                      {/* <span>We Test </span>for over 20+ Disease States{" "} */}
                    </h1>
                  </div>

                  <span className="listsubwrapper">
                    <p>Heart Attack Risk</p>
                    {/* <p>Irregular Heart Beat</p> */}
                    <p>Diabetes with Complications</p>
                    <p>Postpartum Dysfunctions</p>
                    <p>Nerve Damage</p>
                    <h6>And Much More!</h6>
                    {/* <p>And Much More!</p> */}
                    {/* <div className="listing_righttext">
                    <p>Post Covid Complications</p>
                    <p>
                      Nerve Damage{" "}
                      <span className="smrighttxt">
                        (All types includes those leading to organ failure)
                      </span>
                    </p>
                    <p>Atherosclerosis</p>
                    <p>Peripheral Vascular Disease</p>
                  </div> */}
                  </span>
                  {/* <div className="blk1bottomtxt">
                    <h1>
                      <span>We Test </span>for over 20+ Disease States{" "}
                    </h1>
                    <div className="getblackbtnwrp">
                      <button>
                        <a href="#signup"> get started</a>
                      </button>
                    </div>
                  </div> */}
                </div>
              </div>

              <Grid container className="header_bottomwrpr">
                <Grid item className="header_bottominnerwrpr" xs={12}>
                  <h3 className="topheader_bottom">
                    Our Exam is covered by most health insurance carriers
                    including Medicare  {injectData}{" "}
                  </h3>
                </Grid>
              </Grid>
            </div>
          </Grid>

          <div className="pece_mkbannerblock">
            <div className="mknewcontainer">
              <div className="contentwrapper">
                <div className="leftwrp_content">
                  <div className="top_text_wrpr">
                    <div className="textwrapper ">
                      <h1>Come in right away </h1>
                      <h1>for the Number one</h1>
                      <h1> Health Risk Analysis</h1>
                      <h1> in the Country!</h1>

                      <div className="tagimg1wrp">
                        <img src={image1} alt="" />
                      </div>
                    </div>

                    <div className="rightnew_text">
                      <h2>
                        “Worried about your risk of a heart <br></br> attack or
                        diabetes? Work towards <br></br>{" "}
                        <span>prevention today!”</span>
                      </h2>
                    </div>

                    <div className="title1">

                      <h1>
                        According to the CDC, nearly 900,000 Americans die
                        prematurely EACH YEAR! Up to 40% of these deaths could
                        have been prevented!*
                      </h1>
                    </div>

                    {/* <div className="tagimg1wrp">
                        <img src={image1} alt='' />
                      </div> */}
                  </div>

                  <div className="mk_innerleftsection">
                    {/* <div className='pece_mkbannergirlimg'>
                    <img src={image3} />
                  </div> */}

                    {/* <div className="top_text_wrpr">
                      <div className="textwrapper ">
                        <h1>Number one</h1>
                        <h1> Health Risk</h1>
                        <h1> Analysis in </h1>
                        <h1> the Country!</h1>
                      </div>

                      <div className="rightnew_text">
                        <h2>
                          “Worried about your risk of a heart <br></br> attack
                          or diabetes? Work towards <br></br>{" "}
                          <span>prevention today!”</span>
                        </h2>
                      </div>

                      <div className="tagimg1wrp">
                        <img src={image1} alt='' />
                      </div>
                    </div> */}

                    <div className="middle_section_wrpr">
                      <div className="bluebgtextmain">
                        <div className="bluebgtext">
                          <h2>Preventative Health Care is now Available!</h2>
                          <h3>
                            Don’t wait to find out if you may be at risk.{" "}
                          </h3>
                        </div>
                      </div>

                      {/* <div className="organtest_wrpr">
                            <div className="orgn_bnr1">
                              <p>We test for nerve damage!</p>
                            </div>
                            <div className="orgn_bnr1">
                            <p>We test for nerve damage!</p>

                            </div>
                            <div className="orgn_bnr1">
                            <p>We test for nerve damage!</p>

                            </div>
                            <div className="orgn_bnr1">
                            <p>We test for nerve damage!</p>

                            </div>



                    </div> */}
                    </div>

                    <div className="contenttextwrapper">
                      <div className="title1 darktitle">
                        {/* <h1>Come in right away for the number one</h1>
                        <h1> Health Risk Analysis in the Country.</h1> */}
                        <h1>
                          According to the CDC, nearly 900,000 Americans die

                          prematurely EACH YEAR! Up to 40% of these deaths could
                          have been prevented!*
                        </h1>
                      </div>
                      <h2>
                        Our Exam is covered by most health insurance carriers
                        including Medicare
                        {injectData} {/* and Medicaid! */}
                      </h2>
                    </div>
                  </div>
                  <div className="mk_innerrightsection ">
                    {/* <h2>
                      “Worried about your risk of a heart <br></br> attack
                      or diabetes? Work towards <br></br>{" "}
                      <span>prevention today!”</span>
                    </h2> */}
                    <div className="mk_rightimagewrapper">
                      <img
                        src="https://all-frontend-assets.s3.amazonaws.com/pece-marketing-landingpage/assets/images/banner_man.webp"
                        alt=""
                      />
                    </div>

                    <div className="organtest_wrpr">
                      <div className="orgn_bnr1">
                        <p>We test for nerve damage!</p>
                      </div>
                      <div className="orgn_bnr1">
                        <p>We test for heart failure-related issues!</p>
                      </div>
                      <div className="orgn_bnr1">
                        <p>We test for organ function!</p>
                      </div>
                      <div className="orgn_bnr1">
                        <p>We test for pre-diabetes symptoms!</p>
                      </div>
                      {/* <div className="orgn_bnr1">
                        <p>Heart Attack Risk!</p>
                      </div> */}
                    </div>
                  </div>

                  <div className="arrow_Up_text">
                    <h3>You can catch it early with us!</h3>
                  </div>

                  <div className="signup_bannerarrow">
                    <h2>
                      Fill out the form on the right to quickly see if you
                      qualify!
                    </h2>

                    {/* <div className="arrow_Up_text">
                      <h3>You can catch it early with us!</h3>
                    </div> */}

                    {/*<Icon>
                <svg>ArrowDownwardIcon </svg>
              </Icon> */}
                  </div>
                  <div className="pecemk_bannerpara">
                    <p>
                      This analysis will do a full score of your autonomic and
                      vascular systems giving you potentially life saving
                      information about your state of health. Our exam is
                      non-invasive and only{" "}
                      <span className="brtext">
                        takes{" "}
                        <span>
                          20 minutes after a quick patient enrollment.{" "}
                        </span>
                      </span>
                    </p>
                  </div>
                </div>
                <div
                  className="rightwrp_forsection rightwrp_formsection"
                  id="signup"
                >
                  <div className="signupform">
                    <div className="header titlewrapper">
                      <h1>
                        Are you at risk? Don't wait! Get{" "}
                        <span className="highlight-text">
                          Prequalified for our exam.
                        </span>{" "}
                      </h1>
                    </div>
                    <form
                      onSubmit={handleSubmit(onSubmit)}
                      className="form_grp"
                    >
                      <h2>SIGN UP HERE</h2>

                      <Controller
                        name="firstname"
                        control={control}
                        defaultValue=""
                        rules={{ required: true }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            error={Boolean(errors?.firstname)}
                            label="First Name"
                            helperText={
                              errors.firstname && (
                                <span>First Name is Required</span>
                              )
                            }
                          />
                        )}
                      />
                      <Controller
                        name="lastname"
                        control={control}
                        defaultValue=""
                        rules={{ required: true }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            error={Boolean(errors?.lastname)}
                            label="Last Name"
                            helperText={
                              errors.lastname && (
                                <span>Last Name is Required</span>
                              )
                            }
                          />
                        )}
                      />

                      {/* <Controller
                        name="gender"
                        control={control}
                        defaultValue=""
                        rules={{ required: true }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            error={Boolean(errors?.gender)}
                            label="Gender"
                            helperText={
                              errors.gender && <span>Gender is Required</span>
                            }
                          />
                        )}
                      /> */}

                      {/* ===================gender-dropdown================================= */}
                      <Controller
                        name="gender"
                        control={control}
                        defaultValue=""
                        rules={{ required: true }}
                        render={({ field }) => (
                          <FormControl fullWidth error={Boolean(errors?.gender)} className="gender_dropdown">
                            <InputLabel id="demo-simple-select-label">
                              Gender
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={
                                getValues("gender") ? getValues("gender") : ""
                              }
                              label="Gender"
                              onChange={handleChange}

                            >
                              <MenuItem value="female">Female</MenuItem>
                              <MenuItem value="male">Male</MenuItem>
                              <MenuItem value="others">Others</MenuItem>
                            </Select>
                            <FormHelperText>{genderErrorMessage[errors.gender?.type]}</FormHelperText>
                          </FormControl>
                        )}
                      />

                      <Controller
                        name="email"
                        control={control}
                        defaultValue=""
                        rules={{
                          required: true,
                          pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            error={Boolean(errors?.email)}
                            label="Email Address"
                            helperText={
                              errors.email && (
                                <span>
                                  {emailErrorMessage[errors.email.type]}
                                </span>
                              )
                            }
                          />
                        )}
                      />

                      <Controller
                        name="phone_number"
                        control={control}
                        defaultValue=""
                        // rules={{ required: true, minLength: 10, maxLength: 10 }}
                        rules={{ required: true, maxLength: 20 }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            onChange={setPhoneNumber}
                            value={getValues("phone_number") ? getValues("phone_number") : ""}
                            error={Boolean(errors?.phone_number)}
                            label="Phone No"
                            helperText={
                              errors.phone_number && (
                                <span>
                                  {
                                    phoneNumberErrorMessage[
                                    errors.phone_number.type
                                    ]
                                  }
                                </span>
                              )
                            }
                            inputProps={{
                              maxLength: 14,
                            }}
                          />
                        )}
                      />

                      <Controller
                        name="address"
                        control={control}
                        defaultValue=""
                        rules={{ required: true }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            error={Boolean(errors?.address)}
                            label="Address"
                            helperText={
                              errors.address && <span>Address is Required</span>
                            }
                          />
                        )}
                      />

                      {/* <Controller */}

                      {/* <Controller
                        name="state"
                        control={control}
                        defaultValue=""
                        rules={{ required: true }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            error={Boolean(errors?.state)}
                            label="State"
                            helperText={
                              errors.state && <span>State is Required</span>
                            }
                          />
                        )}
                      /> */}

                      <Controller
                        name="city"
                        control={control}
                        defaultValue=""
                        rules={{ required: true }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            error={Boolean(errors?.city)}
                            label="City"
                            helperText={
                              errors.city && <span>City is Required</span>
                            }
                          />
                        )}
                      />





                      <Controller
                        name="state"
                        control={control}
                        defaultValue=""
                        rules={{ required: true }}
                        render={({ onChange, onBlur, value, field }) => (
                          <Autocomplete
                            disablePortal
                            className="form_field"
                            id="combo-box-demo"
                            options={options}
                            onChange={(event, newValue) => {
                              // console.log("newValue", newValue.abbr, event.target.value);
                              setValue('state', newValue.abbr);
                              clearErrors("state");
                              setStateId(newValue._id);
                              if (newValue.value !== "" || newValue.value !== null) {
                                onChangeCity(newValue.value, newValue._id);
                              }
                            }}

                            renderInput={(params) =>
                              <TextField {...params} label="State"
                                error={Boolean(errors?.state)}
                                helperText={errors.state && <span>State is Required</span>}
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <React.Fragment>

                                      {loading ? <CircularProgress color="inherit" size={20} /> : null}

                                    </React.Fragment>
                                  ),
                                }}
                              />}
                          />
                        )}
                      />


                      {/*
                      <Controller
                        name="city"
                        control={control}
                        defaultValue=""
                        rules={{ required: true }}
                        render={({ onChange, onBlur, value, field }) => (
                          <Autocomplete
                            // {...field}
                            disablePortal
                            className="form_field"
                            id="combo-box-demo"
                            options={options_city}
                            onChange={(event, newValue) => {
                              // console.log("newValue", newValue, event.target.value);
                              setValue('city', newValue.label);
                              clearErrors("city");
                            }}
                            renderOption={(props, option) => {
                              return (
                                <li {...props} key={option._id}>
                                  {option.label}
                                </li>
                              );
                            }}
                            renderInput={(params) =>
                              <TextField {...params} label="City"
                                error={Boolean(errors?.city)}
                                helperText={errors.city && <span>City is Required</span>}
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <React.Fragment>
                           
                                      {loading_city ? <CircularProgress color="inherit" size={20} /> : null}
                               
                                    </React.Fragment>
                                  ),
                                }}
                              />}
                          />
                        )}
                      />

                    */}

                      <Controller
                        name="zip_code"
                        control={control}
                        defaultValue=""
                        rules={{ required: true, minLength: 5, maxLength: 5 }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            error={Boolean(errors?.zip_code)}
                            label="Zip Code"
                            helperText={
                              errors.zip_code && (
                                <span>
                                  {zipcodeErrorMessage[errors.zip_code.type]}
                                </span>
                              )
                            }
                            inputProps={{
                              maxLength: 5,
                            }}
                          />
                        )}
                      />
                      {/* <FormControl error={Boolean(errors.terms)} className="termsncondition">
                      <FormControlLabel control={
                        <Controller
                          name="terms"
                          rules={{ required: true, }}
                          control={control}
                          defaultValue={false}
                          render={(props) => (
                            <Checkbox
                              label="test"
                              {...register('terms', { required: 'Please give consent' })}
                            />
                          )}
                        />
                      } label='Are you consenting to have your entered medical information reviewed by the medical practice offering on this page?' />
                      <FormHelperText>{errors.terms?.message}</FormHelperText>
                    </FormControl> */}
                      <div className="buttonSection">
                        <Button
                          type="submit"
                          variant="contained"
                          color="success"
                          className="form_btn"
                        >
                          {" "}
                          Submit
                        </Button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="getblackbtnwrp nxt2banner">
            <button>
              <a href="#signup"> get started</a>
            </button>
          </div>

          <div className="signupblockone mobviewclose">
            <div className="mknewcontainer">
              <div className="subwrapper1">
                <div className="subtitlemainheader">
                  <div className="subtitlemainheaderinner">
                    <h3>We test for the following potential health risks </h3>
                  </div>
                </div>
                <div className="signup_blk1leftimg">
                  <img src={image4} />
                </div>
                <div className="listwrapper">
                  <div className="listsubwrapperbg">
                    <span className="listsubwrapper">
                      <p>Heart Attack Risk</p>
                      <p>Irregular Heart Beat</p>
                      <p>Diabetes with Complications</p>
                      <p>Postpartum Dysfunctions</p>
                      <div className="listing_righttext">
                        <p>Post Covid Complications</p>
                        <p>
                          Nerve Damage{" "}
                          <span className="smrighttxt">
                            (All types includes those leading to organ failure)
                          </span>
                        </p>
                        <p>Atherosclerosis</p>
                        <p>Peripheral Vascular Disease</p>
                      </div>
                    </span>
                    <div className="blk1bottomtxt">
                      <h1>
                        <span>We Test </span>for over 20+ Disease States{" "}
                      </h1>
                      <div className="getblackbtnwrp">
                        <button>
                          <a href="#signup"> get started</a>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="signupblocktwo">
            <div className="mknewcontainer">
              <div className="subwrapper1">
                <div className="subtitlemainheader">
                  <div className="subtitlemainheaderinner">
                    <h3>
                      Are you suffering from any of the following symptoms?
                    </h3>
                  </div>
                </div>

                <div className="signup_blk1leftimg">
                  <img src={image5} />
                </div>
                <div className="listwrapper">
                  <div className="listsubwrapperbg">
                    <span className="listsubwrapper">
                      <p>Blurred Vision</p>
                      <p>Elevated Blood Sugar</p>
                      <p>Extreme Thirst</p>
                      <p>Frequent Urination</p>
                      <p>Fatigue (Tiredness)</p>
                      <p>Heartburn</p>
                      <p>Increased Hunger</p>
                      <p>Nausea</p>
                      <p>Numbness & Tingling in Hands or Feet</p>
                      <p>Vomiting</p>
                      <p>
                        Angina (severe chest pain, often spreading to shoulder,
                        arm, back, neck, or jaw)
                      </p>
                      <p>Chest Pain that goes away with rest</p>

                      <p>Pain in Calves</p>
                      <p>Shortness of Breath</p>
                      <p>Stroke</p>
                      <p>TIA (mini-stroke)</p>
                      <p>Burning Sensations</p>
                      <p>Painful Contact with Socks or Bed Sheets</p>
                      <p>Pebble or Sand-like Sensation in Shoes</p>
                      <p>Stabbing or Electrical Shock Sensation</p>
                      <p>Pins and Needles Sensation in Feet</p>
                      <p>Blood-clot in a vein (Venous Thrombosis)</p>
                      <p>Heart-Attack</p>
                      <p>
                        Irregular heartbeat, too fast/slow (Atrial Fibrillation)
                      </p>
                      <p>Difficulty Digesting Food</p>

                      <p>Dizziness or Fainting</p>
                      <p>Exercise Intolerance</p>
                      <p>Sexual Difficulties</p>
                      <p>Sweat Abnormalities</p>
                      <p>Urinary Problems</p>
                      <p>Headache</p>
                      <p>Swelling of Ankles</p>
                      <p>Cold, Clammy, Pale Skin</p>
                      <p>Depression</p>
                      <p>Lightheadedness</p>
                      <p>Lack of Concentration</p>
                      <p>Lack of Energy</p>
                      <p>Rapid, Shallow Breathing</p>
                    </span>
                  </div>
                </div>

                <div className="contentimgblkwrpmain">
                  <div className="contentimgblkwrp">
                    <div className="lgtblock2contentwhbg">
                      <div className="lgtblock2contentgrybg">
                        <h1>
                          If so we may be able to immediately pre qualify you
                          for this exam. Please fill out the information in the
                          top right. Our online prequalification system will
                          immediately let <br /> you know and give you an
                          opportunity to book your appointment right here on our
                          website!{" "}
                          <span>
                            <a href="#signup">Click here to start now!</a>
                          </span>
                        </h1>

                        <div className="lgtblk2flexwrapper">
                          <div className="blk2greenbgmainwrp">
                            <h2>Get Started now to see if you pre-qualify!</h2>
                          </div>
                          <div className="pointerimgwrp">
                            <a href="#signup">
                              <img src={pointerimg1} />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="block2_docleftimg">
                    <img src={image10} />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="signupblockthree">
            <div className="mknewcontainer">
              <div className="subtitlemainheader">
                <div className="subtitlemainheaderinner">
                  <h3>
                    The following are the 8 areas of health risk that we examine
                    and their explanations.
                  </h3>
                </div>
              </div>
              <div className="blk3humanbodymainbg">
                <div className="inner_blk3bg">
                  <div className="container-fluid nmsfunneldoctor_block3">
                    <div className="nmsfunneldoctor_block_wrapper">
                      <ol>
                        <li className="libase li1">
                          <div className="listwarppercls">
                            <h4>Autonomic Nervous System Dysfunction</h4>
                            <span className="imgwrapperblock3">
                              <img src={tsnewclipimage1} />
                            </span>
                          </div>
                        </li>
                        <li className="libase li2">
                          <div className="listwarppercls">
                            <h4>Insulin Resistance</h4>
                            <span className="imgwrapperblock3">
                              <img src={tsnewclipimage2} />
                            </span>
                          </div>
                        </li>
                        <li className="libase li3">
                          <div className="listwarppercls">
                            <h4>Endothelial Dysfunction.</h4>
                            <span className="imgwrapperblock3">
                              <img src={tsnewclipimage3} />
                            </span>
                          </div>
                        </li>
                        <li className="libase li4">
                          <div className="listwarppercls">
                            <h4>Sudomotor Dysfunction</h4>
                            <span className="imgwrapperblock3">
                              <img src={tsnewclipimage4} />
                            </span>
                          </div>
                        </li>
                        <li className="libase li5">
                          <div className="listwarppercls">
                            <h4>Cardiac Autonomic Neuropathy</h4>
                            <span className="imgwrapperblock3">
                              <img src={tsnewclipimage5} />
                            </span>
                          </div>
                        </li>
                        <li className="libase li6">
                          <div className="listwarppercls">
                            <h4>Cardio- Metabolic Risk</h4>
                            <span className="imgwrapperblock3">
                              <img src={tsnewclipimage6} />
                            </span>
                          </div>
                        </li>
                        <li className="libase li7">
                          <div className="listwarppercls">
                            <h4>Small Fibre Neuropathy</h4>
                            <span className="imgwrapperblock3">
                              <img src={tsnewclipimage7} />
                            </span>
                          </div>
                        </li>
                        <li className="libase li8">
                          <div className="listwarppercls">
                            <h4>Cardio-vascular Disease</h4>
                            <span className="imgwrapperblock3">
                              <img src={tsnewclipimage8} />
                            </span>
                          </div>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
                <div className="getblackbtnwrp">
                  <button>
                    <a href="#signup"> get started</a>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="signupblockfour">
            <div className="mknewcontainer">
              <div className="subtitlemainheader">
                <div className="subtitlemainheaderinner">
                  <h3>
                    Here is a quick review of the 8 health risk factors that our
                    ANS testing is based on.
                  </h3>
                  <h3>
                    You willfind these to be extremely easy to read and act
                    upon.
                  </h3>
                </div>
              </div>
              <div className="innercontentwrpmain">
                <div className="blk4content1main">
                  <div className="content1">
                    <div className="content1mainblock">
                      <div className="contentblkblue">
                        <div className="textwrappermain">
                          <div className="yellowbar">
                            <h1>
                              1. AUTONOMOUS NERVOUS SYSTEM DYSFUNCTION RISK -
                              ANSD
                            </h1>
                          </div>
                          <p>
                            Problems with the ANS can range from mild to
                            life-threatening. Sometimes, only one part of the
                            nervous system is affected. In other cases, the
                            entire ANS is affected. Some conditions are
                            temporary and can be reversed, while others are
                            chronic and will continue to worsen over time.
                            Diseases such as Diabetes or Parkinson’s Disease can
                            cause irregularities with ANS. Problems with ANS
                            regulation often involve organ failure, or the
                            failure of the nerves to transmit <br />a necessary
                            signal.
                          </p>
                        </div>
                        <div className="textwrappermain">
                          <div className="yellowbar">
                            <h1>2. SUDOMOTOR DYSFUNCTION RISK - SudoD</h1>
                          </div>
                          <p>
                            Sudomotor dysfunction testing may indicate to
                            physicians a patient's peripheral nerve and cardiac
                            sympathetic dysfunction. Neuropathy is a common
                            complication in diabetes mellitus (DM), with 60%-70%
                            of patients affected over their lifetime. Symptoms
                            of neuropathy are more common than clinical
                            neuropathy. Neuropathy may remain undetected, and
                            progress over time leading to serious complications.
                            The most common associated clinical condition is
                            peripheral neuropathy, affecting the feet. Autonomic
                            nerve involvement is common but probably the most
                            undiagnosed. Low scores in the sudomotor may lead a
                            medical provider to look at clinical neuropathy.
                          </p>
                        </div>
                        <div className="getblackbtnwrp">
                          <button>
                            <a href="#signup"> get started</a>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="righttimg1">
                    <img src={contentblk1right} />
                  </div>
                </div>
                <div className="blk4content1main2">
                  <div className="content1">
                    <div className="content1mainblock">
                      <div className="contentblkblue">
                        <div className="textwrappermain">
                          <div className="yellowbar">
                            <h1>3. ENDOTHELIAL DYSFUNCTION RISK - EndoD</h1>
                          </div>
                          <p>
                            Current evidence suggests that endothelial function
                            is an integrative marker of the net effects of
                            damage from traditional and emerging risk factors on
                            the arterial wall and its intrinsic capacity for
                            repair. Endothelial dysfunction, detected as the
                            presence of reduced vasodilating response to
                            endothelial stimuli, has been observed to be
                            associated with major cardiovascular risk factors,
                            such as aging, hyperhomocysteinemia, post-menopause
                            state, smoking, diabetes, hypercholesterolemia, and
                            hypertension.
                          </p>
                        </div>
                        <div className="textwrappermain">
                          <div className="yellowbar">
                            <h1>4. INSULIN RESISTANCE RISK - IR</h1>
                          </div>
                          <p>
                            Insulin resistance is defined clinically as the
                            inability of a known quantity of exogenous or
                            endogenous insulin to increase glucose uptake and
                            utilization in an individual as much as it does in a
                            normal population. Insulin resistance occurs as part
                            of a cluster of cardiovascular metabolic
                            abnormalities commonly referred to as "The Insulin
                            Resistance Syndrome" or "The Metabolic Syndrome".
                            This cluster of abnormalities may lead to the
                            development of Type-2 diabetes, accelerated
                            atherosclerosis, hypertension, or polycystic ovarian
                            syndrome depending on the genetic background of the
                            individual developing insulin resistance.
                          </p>
                        </div>
                        <div className="getblackbtnwrp">
                          <button>
                            <a href="#signup"> get started</a>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="righttimg1">
                    <img src={contentblk1right5} />
                  </div>
                </div>
                <div className="blk4content1main3">
                  <div className="content1">
                    <div className="content1mainblock">
                      <div className="contentblkblue">
                        <div className="textwrappermain">
                          <div className="yellowbar">
                            <h1>5. CARDIOMETABOLIC RISK - CMR</h1>
                          </div>
                          <p>
                            The specific factors that can cause this increased
                            risk include obesity (particularly central),
                            hyperglycemia, hypertension, insulin resistance, and
                            dyslipoproteinemia. When patients have one or more
                            risk factors and are physically inactive or smoke,
                            the cardiometabolic risk is increased even more.
                            Medical conditions that often share the above
                            characteristics, such as type 2 diabetes, can also
                            increase cardiometabolic risk. The primary focus of
                            cardiometabolic risk treatment is the man agement of
                            each high-risk factor, including dyslipoproteinemia,
                            hypertension, and diabetes. The management of these
                            subjects is based principally on lifestyle measures,
                            but various antihypertensive, lipid-lowering,
                            insulin-sensitizing, anti-obesity, and antiplatelet
                            drugs could be helpful in reducing cardiometabolic
                            risk.
                          </p>
                        </div>
                        <div className="textwrappermain">
                          <div className="yellowbar">
                            <h1>6. SMALL FIBER NEUROPATHY RISK - SFN</h1>
                          </div>
                          <p>
                            A small fiber neuropathy occurs when damage to the
                            peripheral nerves predominantly or entirely affects
                            the small myelinated fibers or unmyelinated C
                            fibers. The specific fiber types involved in this
                            process include both small somatic and autonomic
                            fibers. The sensory functions of these fibers
                            include thermal perception and nociception. These
                            fibers are involved in many autonomic and enteric
                            functions.
                          </p>
                        </div>
                        <div className="getblackbtnwrp">
                          <button>
                            <a href="#signup"> get started</a>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="righttimg1">
                    <img src={contentblk1right4} />
                  </div>
                </div>
                <div className="blk4content1main4">
                  <div className="content1">
                    <div className="content1mainblock">
                      <div className="contentblkblue">
                        <div className="textwrappermain">
                          <div className="yellowbar">
                            <h1>7. CARDIAC AUTONOMIC NEUROPATHY RISK - CAN</h1>
                          </div>
                          <p>
                            High blood glucose levels over a period of years may
                            cause a condition called autonomic neuropathy. This
                            is damage to the nerves that control the regulation
                            of involuntary function. When the nerve damage
                            affects the heart, it is called cardiac autonomic
                            neuropathy (CAN). CAN encompasses damage to the
                            autonomic nerve fibers that innervate the heart and
                            blood vessels, resulting in abnormalities in heart
                            rate control, vascular dynamics, and the body's
                            ability to adjust blood pressure. CAN is a
                            significant cause of morbidity and mortality
                            associated with a high risk of cardiac arrhythmias
                            and sudden death.
                          </p>
                        </div>
                        <div className="textwrappermain">
                          <div className="yellowbar">
                            <h1>
                              8. PLETHYSMOGRAPHY CARDIOVASCULAR DISEASE RISK -
                              PTG CVD
                            </h1>
                          </div>
                          <p>
                            The PTG CVD risk factor is the combined total of the
                            other seven risk factors assessments. It takes into
                            consideration the cardiovascular as well as the
                            autonomic nervous system (ANS) measurements.
                          </p>
                        </div>
                        <div className="getblackbtnwrp">
                          <button>
                            <a href="#signup"> get started</a>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="righttimg1">
                    <img src={contentblk1right1} />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footersectionwrapper">
            <div className="mknewcontainer">

              <Grid container className="topheader_mainwrpr">
                <div className="mknewcontainer">
                  <MobBanner
                    practiceName={props.practiceName}
                    practiceLogo={props.practiceData.img_url}
                    practiceAddress={props.marketingDetailsData.fulladdress?.address}
                    practiceCity={props.marketingDetailsData.fulladdress?.city}
                    practicePh={props.marketingDetailsData.fulladdress?.phone_no}
                  />

                </div>
              </Grid>

              {/* <img src={footer} className="" /> */}

              {/* {isMobiDemo != 1 ? <img src={props.footer} /> : ""} */}


              <img src={props.footer} className="websize-footerbanner" />

              <div className="mobiban">
                {/* {isDemo == 1 ? (
                  <img src="https://all-frontend-assest.s3.amazonaws.com/pece-marketing-deploy/static/media/12.jpg" />) : ""} */}

                <div className="mobiban">
                  {isMobiDemo == 1 ? (
                    <img src="https://all-frontend-assest.s3.amazonaws.com/pece-marketing-deploy/static/media/12.jpg" />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>

            <div className="copyrighttext">
              <div className="mknewcontainer footercopy">
                <p>
                  Terms & Conditions | Privacy Policy Copyright © 2022 Pece. All
                  Rights Reserved
                </p>
              </div>
            </div>

            {isDemo == 1 || isMobiDemo == 1 ? (
              <div>
                <DemoFooter> </DemoFooter>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Landingnew;
